import { locationMatches } from 'Shared/frontend/widgets/locationMatches';
import { createCssFromSettings } from 'Shared/frontend/widgets/createCssFromSettings';
import { PathElement, TagAndPath } from 'Shared/frontend/widgets/StylesProvider';
import { siteTheme } from 'Shared/frontend/SettingsProvider';


export function applicableStyles(nodePath:PathElement[],styleTagAndPaths:TagAndPath[])
{
//console.log('applicableStyles() nodePath:',nodePath,'styleTagAndPaths:',styleTagAndPaths);	

	let applicable = {css:{}};

	for (const tagAndPaths of styleTagAndPaths) {
		const rules = siteTheme().styles[tagAndPaths.tag];

		for (const rule of rules) {
			const ruleLocExpr = [...tagAndPaths.pathWhenAdded, ...rule.location];

			/* NOTE locExpr and stylePath both use the full paths of the component */
			if (locationMatches(ruleLocExpr,nodePath)) {
				const css = {...applicable.css,...rule.css};
				const settings = {}

				for (const [fieldName,fieldValue] of Object.entries(rule)) 
					createCssFromSettings(fieldName,fieldValue,/*mod*/css,/*mod*/settings);

				applicable = {...applicable, ...settings, css:css};
			}
		}
	}
	delete applicable.location;

	return applicable;
}

